import { Component, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { JwtHelperService } from "@auth0/angular-jwt";
import { AdminViewService } from 'src/app/framework/services/admin-view.service';
const helper = new JwtHelperService();

@Component({
  selector: 'app-consumers',
  templateUrl: './consumers.component.html',
  styleUrls: ['./consumers.component.scss']
})
export class ConsumersComponent extends FeaturesBaseComponent implements OnInit {
  userRole: any;
  isButtonDisabled:boolean
  constructor(private adminViewServices:AdminViewService) {
    super();
    const token: string = localStorage.getItem('accessToken');
    let decoded_token: any = helper.decodeToken(token);
    this.userRole = decoded_token.role;
  }

  ngOnInit(): void {
    super.ngOnInit()
      this.adminViewServices.checkAdminVRole().subscribe((res) => {
      this.isButtonDisabled = res
    })
  
  }

  ngOnDestroy() {
    super.ngOnDestroy()
  }

}
